export var width = {
  values: ['small', 'medium', 'large', 'x-large'],
  widths: {
    small: 400,
    medium: 600,
    large: 800,
    'x-large': 968
  },
  defaultValue: 'medium'
};
export var dialogWidth = function dialogWidth(input) {
  if (!input) {
    return 'auto';
  }
  var isWidthName = width.values.indexOf(input.toString()) !== -1;
  var widthName = isWidthName && input;
  if (widthName) {
    return "".concat(width.widths[widthName], "px");
  }
  return typeof input === 'number' ? "".concat(input, "px") : input;
};
export var dialogHeight = function dialogHeight(input) {
  if (!input) {
    return 'auto';
  }
  return typeof input === 'number' ? "".concat(input, "px") : input;
};